import { Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs";
import { IProductIdProvider } from "../../../interfaces";

@Injectable()
export class ProductManagementComponentService implements IProductIdProvider {

    private _productId = new ReplaySubject<number>(1);
    productId$: Observable<number> = this._productId.asObservable();
    
    setProductId = (identifier: number) => this._productId.next(identifier);

}